/**
 * UI elements
 */
class PP_UI {
	constructor() {
		this.initSmoothScroll();
		this.detectEdge();
		this.initYTVideoWithCover();
		this.initTextAccordion();
		this.initCountDown();
		this.initCountColumns();
    this.initFathomEvents();
	}

	initSmoothScroll () {
		$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&&
				location.hostname == this.hostname
			) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if (target.length) {
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top - 100
					}, 1000);
				}
			}
		});
	}

	detectEdge () {
		if (document.documentMode || /Edge/.test(navigator.userAgent)) {
			document.body.classList.add('browser--is-edge')
		}
	}

	initYTVideoWithCover () {
		let videos = $('.video-with-cover-image');

		if (!videos.length) {
			return;
		}

		for (let i = 0; i < videos.length; i++) {
			let overlay = videos.eq(i);

			videos.eq(i).on('click', e => {
				e.preventDefault();
				overlay.addClass('is-hidden');
				overlay.parent().find('.video-block-media-wrapper').addClass('is-active');
				let iframe = overlay.parent().find('iframe');

				iframe.on('load', function () {
					setTimeout(() => {
						iframe[0].contentWindow.postMessage(JSON.stringify({
						'event': 'command',
						'func': 'playVideo',
						'args': []
						}), '*');
					}, 500);
				});

				iframe.attr('src', iframe.attr('data-src'));
			});
		}
	}

	initTextAccordion () {
		if ($(document.body).hasClass('js-ui-accordion-initialized')) {
			return;
		}

		$(document.body).addClass('js-ui-accordion-initialized');

		$(".js-accordion").each(function(i, item) {
			$(item).find('.js-accordion-content').css('height', 0);

			$(item).on("click", function () {
				let item = $(this);
				let contentWrapper = item.find('.js-accordion-content');
				let contentText = item.find('.js-accordion-content > div');

				item.toggleClass('active');
				let newHeight = contentText.outerHeight();

				if (item.hasClass('active')) {
					contentWrapper.css('height', 0);

					setTimeout(function() {
						contentWrapper.css('height', newHeight + 'px');
					}, 0);

					setTimeout(function() {
						contentWrapper.css('height', 'auto');
					}, 500);
				} else {
					contentWrapper.css('height', newHeight + 'px');

					setTimeout(function() {
						contentWrapper.css('height', 0);
					}, 0);
				}
			});
		});
	}

	initCountDown () {
		if (!$('.pp-timer-wrapper').length) {
			return;
		}

		$('.pp-timer-wrapper').each((i, countdown) => {
			let countdownElements = {
				daysValue: $(countdown).find('.pp-timer-days-count'),
				daysSuffix: $(countdown).find('.pp-timer-days-label'),
				hoursValue: $(countdown).find('.pp-timer-hours-count'),
				hoursSuffix: $(countdown).find('.pp-timer-hours-label'),
				minutesValue: $(countdown).find('.pp-timer-minutes-count'),
				minutesSuffix: $(countdown).find('.pp-timer-minutes-label'),
				secondsValue: $(countdown).find('.pp-timer-seconds-count'),
				secondsSuffix: $(countdown).find('.pp-timer-seconds-label'),
			};

			ppCalculateCountdown($(countdown), countdownElements);
		});
	}

	initCountColumns () {
		let columnsBlock = $('.wp-block-columns');

		if (!columnsBlock.length) {
			return;
		}

		for (let i = 0; i < columnsBlock.length; i++) {
			columnsBlock.eq(i).attr('data-count', columnsBlock.eq(i).find('.wp-block-column').length);
    	}
	}

  initFathomEvents () {
    let linksWithEvents = $('a[data-fathom-event]');

    for (let i = 0; i < linksWithEvents.length; i++) {
      let link = linksWithEvents.eq(i);

      if (link.attr('data-fathom-event')) {
        link.on('click', e => {
          let eventName = link.attr('data-fathom-event');

          if (fathom && eventName) {
            fathom.trackEvent(eventName.replace('&nbsp;', ''));
          }
        });
      }
    }
  }
}

function ppCalculateCountdown (countdown, countdownElements) {
	let countTo = parseInt(countdown.attr('data-timestamp-utc'), 10) * 1000;
	let currentTime = new Date().getTime();

    if (countTo - currentTime > 0) {
        let diff = countTo - currentTime;
        let days = Math.floor(diff / (24 * 60 * 60 * 1000));
        let hoursDiff = diff - (days * 24 * 60 * 60 * 1000);
        let hours = (Math.floor(hoursDiff / (60 * 60 * 1000))) % 24;
        let minutesDiff = hoursDiff - (hours * 60 * 60 * 1000);
        let minutes = (Math.floor(minutesDiff / (60 * 1000))) % 60;
		let seconds = Math.floor((minutesDiff - (minutes * 60 * 1000)) / 1000);
        let daysSuffix = days === 1 ? 'dzień' : 'dni';
        let hoursSuffix = 'godzin';
        let minutesSuffix = 'minut';
		let secondsSuffix = 'sekund';

        if (hours === 1) {
            hoursSuffix = 'godzina';
        } else if (hours === 2 || hours === 3 || hours === 4 || hours === 22 || hours === 23) {
            hoursSuffix = 'godziny';
        }

        if (minutes === 1) {
            minutesSuffix = 'minuta';
        } else if (
            minutes === 2 || minutes === 3 || minutes === 4 || 
            minutes === 22 || minutes === 23 || minutes === 24 || 
            minutes === 32 || minutes === 33 || minutes === 34 || 
            minutes === 42 || minutes === 43 || minutes === 44 || 
            minutes === 52 || minutes === 53 || minutes === 54
        ) {
            minutesSuffix = 'minuty';
        }

		if (seconds === 1) {
            secondsSuffix = 'sekunda';
        } else if (
            seconds === 2 || seconds === 3 || seconds === 4 || 
            seconds === 22 || seconds === 23 || seconds === 24 || 
            seconds === 32 || seconds === 33 || seconds === 34 || 
            seconds === 42 || seconds === 43 || seconds === 44 || 
            seconds === 52 || seconds === 53 || seconds === 54
        ) {
            secondsSuffix = 'sekundy';
        }

		countdownElements.daysValue.text(days);
		countdownElements.daysSuffix.text(daysSuffix);
		countdownElements.hoursValue.text(hours);
		countdownElements.hoursSuffix.text(hoursSuffix);
		countdownElements.minutesValue.text(minutes);
		countdownElements.minutesSuffix.text(minutesSuffix);
		countdownElements.secondsValue.text(seconds);
		countdownElements.secondsSuffix.text(secondsSuffix);

        setTimeout(() => {
            ppCalculateCountdown (countdown, countdownElements);
        }, 1000);
    } else {
        countdown.find('.pp-timer').addClass('is-hidden');
		countdown.find('.pp-timer-finished').removeClass('is-hidden');
    }
}
